import {l} from "types/typescriptdefinisjoner_lederplan";
import {BasisRessurs} from "felles/infrastruktur/BasisRessurs";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {Strenger} from "../Strenger";
import {Debugger} from "debug";
import {resource} from "angular";

const debug: Debugger = require('debug')('ArkivRessurs');

export class ArkivRessurs extends BasisRessurs<l.ArkivnodeModell<any>> {

    static regNavn = 'ArkivRessurs';

    static forInjisering() {
        return [
            regNavn.ng.$resource,
            RessursFeilhåndtering.regNavn,
            Strenger.regNavn,
            regNavn.gettext.gettextCatalog,
            ArkivRessurs
        ]
    }

    constructor($resource: ng.resource.IResourceService,
                ressursFeilhåndtering: RessursFeilhåndtering,
                private strenger: Strenger,
                gettextCatalog: gettextCatalog) {
        super('arkiv',
            $resource,
            ressursFeilhåndtering,
            gettextCatalog,
            {
                lastRot: {method: 'GET', url: '/api/arkiv/rot'},
                lastRotForGruppe: {method: 'GET', url: '/api/arkiv/rot/:gruppeId', params: {gruppeId: '@gruppeId'}},
                lastMappe: {method: 'GET', url: '/api/arkiv/mappe/:id', params: {id: '@id'}},
                lastFil: {method: 'GET', url: '/api/arkiv/fil/:id', params: {id: '@id'}},
                lastFilTilknyttetDokumentId: {method: 'GET', url: '/api/arkiv/filTilknyttetDokumentId/:id', params: {id: '@id'}},
                lastFilTilknyttetDokumentVersjonId: {method: 'GET', url: '/api/arkiv/filTilknyttetDokumentVersjonId/:id', params: {id: '@id'}},
                lastSakerKnyttetTilArkivdokument: {method: 'GET', url: '/api/arkiv/sakerKnyttetTilArkivdokument/:dokumentId', params: {dokumentId: '@dokumentId'}, isArray: true},
                lastSakerKnyttetTilArkivdokumenterIMappe: {method: 'GET', url: '/api/arkiv/sakerKnyttetTilArkivdokumenterIMappe/:mappeId', params: {mappeId: '@mappeId'}, isArray: true},
                slettFil: {method: 'DELETE', url: '/api/arkiv/fil/:id', params: {id: '@id'}},
                opprettMappe: {method: 'PUT', url: '/api/arkiv/:forelder/mappe', params: {forelder: '@forelder'}},
                oppdaterMappe: {method: 'POST', url: '/api/arkiv/mappe/:id', params: {forelder: '@id'}},
                slettMappe: {method: 'DELETE', url: '/api/arkiv/mappe/:id?rekursivt=:rekursivt', params: {id: '@id', rekursivt: '@rekursivt'}},
                flytt: {method: 'POST', url: '/api/arkiv/:id/flytt'},
                hentSkjerming: {method: 'GET', url: '/api/arkiv/mappe/:id/skjerming', isArray: false},
                oppdaterSkjerming: {method: 'POST', url: '/api/arkiv/mappe/:id/skjerming', isArray: false, params: {id:'@id'}}
            });
    }

    //offentlige metoder


    lastRot(): l.ArkivMappenodeModell {
        debug('lastRot');
        return this.ressurs['lastRot'](
            {},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke laste bibliotekrot'))
        );
    }

    lastRotForGruppe(gruppeId: string): l.ArkivMappenodeModell {
        debug('lastRotForGruppe', gruppeId);
        return this.ressurs['lastRotForGruppe'](
            {gruppeId: gruppeId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke laste bibliotekrot for gruppe'))
        );
    }

    lastMappe(id: string, vedFeil: (feil: resource.IResourceResponse) => boolean = () => false): l.ArkivMappenodeModell {
        debug('lastMappe', id);
        return this.ressurs['lastMappe'](
            {id: id},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke laste bibliotekmappe'), vedFeil)
        );
    }

    lastFil(id: string): l.ArkivFilnodeModell {
        debug('lastFil', id);
        return this.ressurs['lastFil'](
          {id: id},
          _.noop,
          this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke laste bibliotekfil'))
        );
    }

    lastFilTilknyttetDokumentId(id: string): l.ArkivFilnodeModell {
        debug('lastFilTilknyttetDokumentId', id);
        return this.ressurs['lastFilTilknyttetDokumentId'](
            {id: id},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke laste bibliotekfil'))
        );
    }

    lastFilTilknyttetDokumentVersjonId(id: string): l.ArkivFilnodeModell {
        debug('lastFilTilknyttetDokumentVersjonId', id);
        return this.ressurs['lastFilTilknyttetDokumentVersjonId'](
            {id: id},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke laste bibliotekfil'))
        );
    }

    lastSakerKnyttetTilArkivdokument(dokumentId: string): ng.resource.IResourceArray<l.DokumentVersjonOgSakerModell> {
        debug('lastSakerKnyttetTilArkivdokument', dokumentId);
        return this.ressurs['lastSakerKnyttetTilArkivdokument'](
            {dokumentId: dokumentId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke laste saker knyttet til bibliotekfil'))
        );
    }

    lastSakerKnyttetTilArkivdokumenterIMappe(mappeId: string): ng.resource.IResourceArray<l.DokumentVersjonOgSakerModell> {
        debug('lastSakerKnyttetTilArkivdokumenterIMappe', mappeId);
        return this.ressurs['lastSakerKnyttetTilArkivdokumenterIMappe'](
            {mappeId: mappeId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke laste saker knyttet til bibliotekfiler'))
        );
    }

    slettFil(id: string): l.ArkivMappenodeModell {
        debug('slettFil', id);
        return this.ressurs['slettFil'](
            {id: id},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke slette fil'))
        );
    }

    opprettMappe(nyMappeSpesifikasjon: l.NyMappeSpesifikasjon): l.ArkivMappenodeModell {
        debug('opprettMappe', nyMappeSpesifikasjon);
        return this.ressurs['opprettMappe'](
            nyMappeSpesifikasjon,
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke registrere ny mappe'))
        );
    }

    oppdaterMappe(mappeId: string, oppdaterMappeSpesifikasjon: l.OppdaterMappeSpesifikasjon): l.ArkivMappenodeModell {
        debug('oppdaterMappe', oppdaterMappeSpesifikasjon);
        return this.ressurs['oppdaterMappe'](
            _.defaults({id: mappeId}, oppdaterMappeSpesifikasjon),
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke oppdatere mappe'))
        );
    }

    flytt(kildeId: string, målMappeId: string): l.ArkivMappenodeModell {
        debug('flytt', kildeId, målMappeId);
        return this.ressurs['flytt'](
            {id: kildeId, målmappe: målMappeId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke flytte element'))
        );
    }

    slettMappe(mappeId: string, rekursivt = false): l.ArkivMappenodeModell {
        debug('slettMappe', mappeId, rekursivt);
        return this.ressurs['slettMappe'](
            {id: mappeId, rekursivt: rekursivt},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke slette mappe'))
        );
    }

    hentSkjerming(mappeId: string): l.SkjermingDetaljerModell {
        debug('hentSkjerming', mappeId);
        return <l.SkjermingDetaljerModell><any>this.ressurs['hentSkjerming'](
            {id: mappeId},
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke hente mappe'))
        );
    }

    oppdaterSkjerming(mappeId: string, spesifikasjon:l.OppdaterSkjermingSpesifikasjon): l.ValideringsresultatModell<l.SkjermingValideringsfeil> {
        debug('oppdaterSkjerming', mappeId);
        return this.ressurs['oppdaterSkjerming'](
            _.defaults({id: mappeId}, spesifikasjon),
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke oppdatere tilgangsbegrensning'))
        );
    }
    //statiske hjelpemetoder

}

